// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_94-0";